import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PendingUser {
  user_id: string;
  email: string | null;
  created_at: string | null;
}

export interface AdminUser {
  user_id: string;
  email: string | null;
  full_name: string | null;
  role: string;
  permission_role: string;
  org_name: string | null;
  approved: boolean;
  created_at: string | null;
  last_sign_in_at: string | null;
}

export function useAdminPendingUsers(enabled: boolean, refetchInterval: number | false) {
  return useQuery<PendingUser[]>({
    queryKey: ['admin-pending-users'],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('No session');

      const { data, error } = await supabase.functions.invoke('user-approval', {
        method: 'GET',
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      if (error) throw error;
      return (data?.pending ?? []) as PendingUser[];
    },
    enabled,
    refetchInterval,
  });
}

export function useAdminAllUsers(enabled: boolean, refetchInterval: number | false) {
  return useQuery<AdminUser[]>({
    queryKey: ['admin-all-users'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('admin_list_users');
      if (error) throw error;
      return (data ?? []) as AdminUser[];
    },
    enabled,
    refetchInterval,
  });
}
